import { render, staticRenderFns } from "./ComplainWorkOrder.vue?vue&type=template&id=c3153786&scoped=true"
import script from "./ComplainWorkOrder.vue?vue&type=script&lang=js"
export * from "./ComplainWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./ComplainWorkOrder.vue?vue&type=style&index=0&id=c3153786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3153786",
  null
  
)

export default component.exports